<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("legal.menu.navigation") }} </template>
        <template #sidebarCta>
            <div class="space-x-2">
                <ButtonSecondaryIconSm
                    v-tooltip="$t('legal.navigation.add_category')"
                    @click="$emit('addCategory')"
                    ><FolderAddIcon
                /></ButtonSecondaryIconSm>
                <ButtonSecondaryIconSm
                    v-tooltip="$t('legal.navigation.add_link')"
                    @click="$emit('addLink')"
                    ><LinkAddIcon
                /></ButtonSecondaryIconSm>
            </div>
        </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <CategoryCard
                    v-for="category in categoriesList"
                    :key="category.id"
                    :category="category"
                    @editCategory="editCategory(category)"
                    @editLink="editLink"
                    @addLink="$emit('addLink', category)"
                    @deleteCategory="deleteCategory(category)"
                />
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import { ButtonSecondaryIconSm } from "@easy/ui/buttons";
import { FolderAddIcon, LinkAddIcon } from "@easy/ui/icons";
import CategoryCard from "./CategoryCard.vue";
import { useSaveOrDropModal } from "@/store/useSaveOrDropModal";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    computed: {
        ...mapState("legal", ["footer", "categories", "hasChanges"]),
        categoriesList() {
            return this.categories.filter((c) => !c._deleted);
        },
    },
    components: {
        PageSidebar,
        CategoryCard,
        ButtonSecondaryIconSm,
        FolderAddIcon,
        LinkAddIcon,
        cSaveButton,
    },
    emits: ["editCategory", "addCategory", "editLink", "addLink"],
    setup() {
        return useSaveOrDropModal();
    },
    methods: {
        ...mapActions("legal/projects", ["loadProject", "saveSnapshot"]),
        ...mapActions("modals", ["showConfirmModal"]),
        ...mapMutations("legal", ["removeCategory"]),
        ...mapActions("alert", ["showErrorMessage"]),
        async deleteCategory(category) {
            if (this.categoriesList.length <= 1) {
                this.showErrorMessage({
                    title: this.$t("legal.navigation.cannot_delete_category"),
                    message: this.$t("legal.navigation.cannot_delete_category_message"),
                });
                return;
            }
            const decision = await this.showConfirmModal({
                title: this.$t("legal.navigation.delete_category_confirm"),
                description: this.$t("legal.navigation.delete_category_message"),
                ctaLabel: this.$t("shared.delete"),
            });
            if (decision) {
                this.removeCategory(category);
            }
        },
        async editCategory(category) {
            await this.askToConfirmIfNeeded({
                showModal: this.hasChanges,
                onConfirmChanges: async () => this.saveSnapshot(),
                onDropChanges: async () => this.loadProject(this.footer.uuid),
            });
            this.$emit("editCategory", category);
        },
        async editLink(link) {
            await this.askToConfirmIfNeeded({
                showModal: this.hasChanges,
                onConfirmChanges: async () => this.saveSnapshot(),
                onDropChanges: async () => this.loadProject(this.footer.uuid),
            });
            this.$emit("editLink", link);
        },
    },
};
</script>
